/**
 * Generate a Facebook sharing link
 *
 * @param  {String} url The url to be shared
 * @return {String}
 */
export function generateFacebookLink (url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

/**
 * Generate a Twitter sharing link
 *
 * @param  {String} url  The url to be shared
 * @param  {String} text The text to be shared
 * @return {String}
 */
export function generateTwitterLink (url, text) {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
}

/**
 * Generate a WhatsApp sharing link
 *
 * @param  {String} url  The url to be shared
 * @param  {String} text The text to be shared
 * @return {String}
 */
export function generateWhatsAppLink (url, text) {
  const shareText = `${text} ${url}`;
  return `https://api.whatsapp.com/send?phone=&text=${encodeURIComponent(shareText)}&source=&data=`;
}

/**
 * Generate a WhatsApp sharing link
 *
 * @param  {String} url  The url to be shared
 * @param  {String} text The text to be shared
 * @return {String}
 */
export function generateLinkedInLink (url, text) {
  return `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(url)}`;
}

/**
 * Generate a Bluesky sharing link
 *
 * @param  {String} url  The url to be shared
 * @param  {String} text The text to be shared
 * @return {String}
 */
export function generateBlueskyLink (url, text) {
  const shareText = `${text} ${url}`;
  return `https://bsky.app/intent/compose?text=${encodeURIComponent(shareText)}`;
}

/**
 * Generate an 'Email to a friend' sharing link
 *
 * @param  {String} url   The url to be shared
 * @param  {String} text  The text to be shared
 * @param  {String} email The email address of the recipient
 * @return {String}
 */
export function generateEmailLink (url, text, email = '') {
  const shareText = `${text} ${url}`;
  return `mailto:${email}?subject=&body=${encodeURIComponent(shareText)}`;
}

export default {
  generateFacebookLink,
  generateTwitterLink,
  generateWhatsAppLink,
  generateLinkedInLink,
  generateBlueskyLink,
  generateEmailLink
};
